export interface IFinanceiroButtonStyle {
  icon: string;
  color: string;
  textColor: string;
  backgroundColor: string;
  singular: string;
  plural: string;
}

export enum EFinanceiroButton {
  boletosEmitidos = "boletos-emitidos",
  boletosVencemEmTresDias = "boletos-vencem-em-tres-dias",
  boletosVencemHoje = "boletos-vencem-hoje",
  boletosEmitidosVencidos = "boletos-emitidos-vencidos",
  boletosVencidosTresDiasOuMais = "boletos-vencidos-tres-dias-ou-mais",
  boletosVencidosVinteDiasOuMais = "boletos-vencidos-vinte-dias-ou-mais"
}

export interface IFinaceiroButtonToStyleMap {
  [EFinanceiroButton.boletosEmitidos]: IFinanceiroButtonStyle;
  [EFinanceiroButton.boletosVencemEmTresDias]: IFinanceiroButtonStyle;
  [EFinanceiroButton.boletosVencemHoje]: IFinanceiroButtonStyle;
  [EFinanceiroButton.boletosEmitidosVencidos]: IFinanceiroButtonStyle;
  [EFinanceiroButton.boletosVencidosTresDiasOuMais]: IFinanceiroButtonStyle;
  [EFinanceiroButton.boletosVencidosVinteDiasOuMais]: IFinanceiroButtonStyle;
}

export const EFinanceiroButtonGetter: IFinaceiroButtonToStyleMap = {
  [EFinanceiroButton.boletosEmitidos]: {
    icon: "picture_as_pdf",
    color: "#0089D4",
    textColor: "#0089D4",
    backgroundColor: "#EFF9FF",
    singular: "Seu boleto deste mês já está disponível para pagamento.",
    plural: "Seus boletos deste mês já estão disponíveis para pagamento."
  },
  [EFinanceiroButton.boletosVencemEmTresDias]: {
    icon: "picture_as_pdf",
    color: "#0089D4",
    textColor: "#0089D4",
    backgroundColor: "#EFF9FF",
    singular:
      "O seu boleto está disponível para pagamento com vencimento para os próximos três dias.",
    plural:
      "Os seus boletos estão disponíveis para pagamento com vencimento para os próximos três dias."
  },
  [EFinanceiroButton.boletosVencemHoje]: {
    icon: "picture_as_pdf",
    color: "#E34812",
    textColor: "#E34812",
    backgroundColor: "#FFF2E0",
    singular:
      "O seu boleto está disponível para pagamento com vencimento na data de hoje.",
    plural:
      "Os seus boletos estão disponíveis para pagamento com vencimento na data de hoje."
  },
  [EFinanceiroButton.boletosEmitidosVencidos]: {
    icon: "warning",
    color: "#FF4848",
    textColor: "#FF4848",
    backgroundColor: "#FFEBEE",
    singular: "Identificamos pendências financeiras em seu cadastro",
    plural: "Identificamos pendências financeiras em seu cadastro"
  },
  [EFinanceiroButton.boletosVencidosTresDiasOuMais]: {
    icon: "warning",
    color: "#FF4848",
    textColor: "#FF4848",
    backgroundColor: "#FFEBEE",
    singular:
      "Notamos um boleto pendente de pagamento. Para conferi-lo, clique no botão ao lado.",
    plural:
      "Notamos que existem boletos pendentes de pagamento. Para conferi-los, clique no botão ao lado."
  },
  [EFinanceiroButton.boletosVencidosVinteDiasOuMais]: {
    icon: "warning",
    color: "#FF4848",
    textColor: "#FF4848",
    backgroundColor: "#FFEBEE",
    singular:
      "Notamos que existe um boleto pendente de pagamento há mais de 20 dias. Faça o pagamento para regularizar o seu cadastro e evitar o bloqueio de seu acesso.",
    plural:
      "Notamos que existem boletos pendentes de pagamento há mais de 20 dias. Faça o pagamento dos boletos para regularizar o seu cadastro e evitar o bloqueio de seu acesso."
  }
};
